import { APIClient } from "../utils/axiosCustomize";
import { endpoints } from "../utils/constants/endpoints";

const axios = new APIClient();

export const getSites = async (query) => {
  try {
    const response = await axios.get(
      endpoints.Site + "/getSites",
      {
        ...query,
      }
    );

    const { data, total, pageSize, pageIndex } = response?.data;

    const dataWithKey = data?.map((i) => {
      return { ...i, key: i.Id };
    });

    return { data: dataWithKey, total, pageSize, pageIndex };
  } catch (err) {
    return [];
  }
};

export const getSiteDetail = async (id) => {
  const { data } = await axios.get(endpoints.Site + `/getById?id=${id}`);
  return data;
};

export const insertSite = async (body) => {
  const data = await axios.post(endpoints.Site + `/insert`, body);
  return data;
};

export const updateSite = async (body) => {
  const data = await axios.put(endpoints.Site + `/update`, body);
  return data;
};

export const deleteSite = async (id) => {
  const data = await axios.delete(endpoints.Site + `/delete?id=${id}`);
  return data;
};
